<template>
	<div>
		<div>
			<div class="title-top">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.TeamInformation }}</div>
			</div>
			<div class="fls">
				<div>
					<span>{{ languageJson.CurrentGroup }}</span>
					<span>{{ groupInfo.groupingName }}</span>
				</div>
			</div>
			<div class="fls">
				<div>
					<span>{{ languageJson.CurrentClasses }}</span>
					<span v-if="groupInfo.staffName">{{ groupInfo.schedulingName }}，{{ groupInfo.schedulingTime }}</span>
					<span v-else>-</span>
				</div>
			</div>
			<div class="fls flbj">
				<div>
					<span>{{ languageJson.CurrentStaff }}</span>
					<span>{{ groupInfo.staffName ? groupInfo.staffName : '-' }}</span>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data() {
			return {
				languageJson: languageJson
			}
		},
		props: {
			groupInfo: null
		},
		mounted() {

		},
		methods: {

		},
		watch: {}
	}
</script>

<style scoped lang="less">
	.title-top {
		display: flex;
		color: #fff;
		font-size: 0.8vw;
		align-items: center;
		justify-content: flex-start;
		margin: 0.5vw;
		padding-bottom: 0.3vw;
		border-bottom: 1px solid rgba(0, 240, 255, 0.1);
		&-text {
			text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
			background: linear-gradient(180deg, #FFFFFF 0%, #00e0ff 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-weight: bold;
			color: #FFFFFF;
			letter-spacing: 2px;
		}

		img {
			width: 1vw;
			margin-right: 0.3vw;
			filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
		}
	}

	.fls {
		display: flex;
		color: #fff;
		line-height: 2vw;
		text-align: left;
		margin-bottom: 0.5vw;
		font-size: 0.8vw;

		>div:nth-child(1) {
			flex: 1;
			height: 2vw;
			background: linear-gradient(90deg, rgba(0, 40, 100, 0.5), rgba(0, 15, 50, 0.2));
			border-left: 2px solid rgba(0, 240, 255, 0.4);
			border-radius: 0 4px 4px 0;
			padding-left: 0.5vw;

			>span:nth-child(1) {
				color: rgba(180, 220, 255, 0.7);
				margin: 0 0.5vw 0 0.5vw;
				font-size: 0.7vw;
			}

			>span:nth-child(2) {
				color: #00f0ff;
				font-weight: 600;
				font-size: 0.8vw;
				text-shadow: 0 0 6px rgba(0, 240, 255, 0.3);
			}

			margin: 0 12px 0 12px;
			transition: all 0.3s ease;
			&:hover {
				background: linear-gradient(90deg, rgba(0, 50, 120, 0.6), rgba(0, 20, 60, 0.3));
				border-left-color: rgba(0, 240, 255, 0.7);
			}
		}
	}

	.flbj {
		>div:nth-child(1) {
			flex: 1;
			height: 2vw;
			background: linear-gradient(90deg, rgba(0, 60, 130, 0.5), rgba(0, 20, 60, 0.2));
			border-left: 2px solid rgba(0, 200, 255, 0.5);
			border-radius: 0 4px 4px 0;
			padding-left: 0.5vw;
		}
	}
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/topRight.vue